export const apiCreate = (): string => '/commercial/dishesTypes/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/dishesTypes/' : `/commercial/dishesTypes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/dishesTypes/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/dishesTypes/delete/${id}`
